<template>
    <module-box
        class="md-testimonial slider-standard"
        :fullColumn="fullColumn"
        :topSpacing="topSpacing"
        :btmSpacing="btmSpacing"
        :mobileTopSpacing="mobileTopSpacing"
        :mobileBtmSpacing="mobileBtmSpacing"
        v-if="testimonials.length"
        noPadding
    >
        <site-img
            type="bgImg"
            dir="width"
            class="testimonial-frame"
            :src="bgType == 'img' ? suitableImg : ''"
            :style="{ 'background-color': bgType == 'color' ? bgColor : null }"
        >
            <div class="testimonial-container">
                <div v-if="title" class="mg-title" v-html="formatFontSize(title, '--mg-title-size')"></div>
                <swiper
                    class="testimonial-swiper"
                    v-bind="options"
                >
                    <slide
                        v-for="item in testimonials"
                        :key="item.id"
                        class="testimonial"
                        @click="()=>toViewMore(item)"
                    >
                        <img v-if="item.rmaTrackPixelUrl" class="rma-pixel-img" :src="item.rmaTrackPixelUrl" loading="lazy" />
                        <div class="testimonial-item-container">
                            <p
                                class="testimonial-body"
                                v-html="item.reviewContent"
                            ></p>
                            <div class="testimonial-footer">
                                <img-box
                                    v-if="item.avatarLink"
                                    class="testimonial-picture"
                                    aria-hidden="true"
                                    :src="item.avatarLink"
                                    dir="height"
                                ></img-box>
                                <div>
                                    <ReviewScore
                                        :sourceType="item.sourceType"
                                        :score="item.reviewRate"
                                        :iconSize="14"
                                        :iconSpace="6"
                                    />
                                    <p
                                        class="testimonial-name"
                                        v-html="item.reviewerName"
                                    ></p>
                                    <p
                                        v-if="item.transactionInfo"
                                        class="testimonial-transactionInfo"
                                    >
                                        {{ item.transactionInfo }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <ReviewSourceLogo :sourceType="item.sourceType" />
                    </slide>
                </swiper>
                <div
                    v-show="options.pagination"
                    class="swiper-pagination"
                    ref="pagination"
                ></div>
                <div
                    v-show="options.navigation"
                    ref="prev"
                    class="prevbutton iconfont icon-prev"
                ></div>
                <div
                    v-show="options.navigation"
                    ref="next"
                    class="nextbutton iconfont icon-next"
                ></div>
            </div>
        </site-img>
    </module-box>
</template>

<script>
import common from '../index';
import commonSlide from '../mixin-slide';
export default {
    mixins: [common, commonSlide],
    data: function() {
        return {
            slidesPerView: 2
        };
    },
    computed: {
        enableNavigation() {
            return this.testimonials.length > 2;
        }
    }
};
</script>

<style lang="scss">
@import './style.scss';
</style>
